import React, { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, useTheme } from "@mui/material";
import { Link } from "gatsby";

let defaultHeaders = [
	{ field: "id", headerName: "ID", width: 90, hide: true },
	{
		field: "title",
		headerName: "Title",
		minWidth: 250,
		editable: true,
	},
];

function ListTable({ rows, columns, configs }) {
	const theme = useTheme();
	const [columnsHeaders, setColumnsHeaders] = React.useState([]);

	const linkColor = theme.palette.excerptLink
		? theme.palette.excerptLink
		: theme.palette.link;

	useEffect(() => {
		// Map column values
		const cols = getHeadersToShow();
		setColumnsHeaders(cols);
	}, [columns]);

	const getHeadersToShow = () => {
		const _defaultHeaders = attachCellLinks(defaultHeaders);
		let cols = [..._defaultHeaders];
		let keyLabels = columns?.split("\r\n");

		keyLabels?.forEach((keyLabelItem) => {
			const keyLabelSplitted = keyLabelItem.split("|");

			if (Array.isArray(keyLabelSplitted)) {
				let field_name = keyLabelSplitted[0];
				field_name = field_name?.trim();
				let label = keyLabelSplitted[1];

				if (field_name && label) {
					cols = [
						...cols,
						{
							field: field_name,
							headerName: label,
							minWidth: 600 / keyLabelSplitted.length,
							editable: true,
						},
					];
				}
			}
		});

		return cols;
	};

	const attachCellLinks = (headers) => {
		const index = headers.findIndex((header) => header.field == "title");

		if (index != -1) {
			headers[index]["renderCell"] = (params) => {
				const { row, value: title } = params;
				let attrs = {
					component: row.external ? "a" : Link,
					target: row.external ? "_blank" : "_self",
					sx: {
						overflow: "hidden",
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						display: "block",
						textDecoration: "none",
						color: linkColor.main,
						"&:hover, &:active, &:focus": {
							color: linkColor.hover,
							textDecoration: "underline",
						},
					},
				};
				if (row.external) {
					attrs.href = row.slug;
				} else {
					attrs.to = row.slug;
				}

        const hasConfig = configs[row.type] != undefined;
        
				return (
					<div>
						{(row.slug && hasConfig) ? <Box {...attrs}>{title}</Box> : <span>{title}</span>}
					</div>
				);
			};
		}

		return headers;
	};

	// remove repeated
	rows = rows?.filter(
		(value, index, self) => index === self.findIndex((t) => t.id === value.id)
	);

  // join array data types
  rows = rows.map(row => {
    Object.keys(row).forEach(key => {
      if(Array.isArray(row[key])) {
        row[key] = row[key].join(', ')
      }
    });
    return { ...row }
  });

	return (
		<div style={{ width: "100%" }}>
			<DataGrid
				columnVisibilityModel={{
					id: false,
				}}
				rows={rows}
				columns={columnsHeaders}
				loading={rows == null}
				autoHeight
			/>
		</div>
	);
}

export default ListTable;
